// classes import
import { PackingListModelProvider } from './packing-list-model';
import { SkuMetadataModelProvider } from './sku-metadata-model';
import { OrderTermModelProvider } from './order-term-model';

export const classes = [
  // classes export
  PackingListModelProvider,
  SkuMetadataModelProvider,
  OrderTermModelProvider,
];
